var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHcpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff7e74;}.cls-2{fill:#e04444;}.cls-3{fill:#febe10;}.cls-4{fill:#fff;}.cls-5{fill:#ffc5bd;}.cls-6{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hcpi_new",
    "data-name": "hcpi new"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.28,469.91l0,0c-10.11-25.84-4.45-52.78-7.79-95.85-.08-1.09-.17-2.16-.25-3.21-.11-1.35-.22-2.68-.33-4-.09-1.08-.18-2.15-.27-3.2-.07-.83-.14-1.64-.21-2.44s-.13-1.5-.2-2.24c-.28-3.16-.57-6.14-.85-8.95-.06-.69-.13-1.38-.2-2.05l-.12-1.16c-.1-.94-.19-1.86-.29-2.75-.14-1.26-.27-2.49-.4-3.67-.66-5.92-1.29-10.86-1.85-14.9-.11-.85-.22-1.66-.34-2.42,0-.26-.07-.51-.11-.76-.22-1.5-.42-2.85-.62-4.05v0c0-.36,0-.72-.05-1.09l-.15-.14a95.2,95.2,0,0,0-21.54-13.78q-2.91-1.35-5.91-2.51A96.54,96.54,0,0,0,352,294.26H241.59a96.53,96.53,0,0,0-34.11,6.18q-3,1.14-5.95,2.48a94.74,94.74,0,0,0-21.6,13.59c-.07.43-.15.88-.22,1.35v0c-.19,1.2-.4,2.55-.62,4.05,0,.25-.07.5-.11.76s-.07.51-.11.78l-.06.4c0,.13,0,.27-.05.41l-.12.83c-.56,4-1.19,9-1.85,14.9-.13,1.18-.26,2.4-.4,3.66-.07.64-.13,1.28-.2,1.93s-.14,1.32-.21,2-.13,1.35-.2,2q-.43,4.37-.88,9.28c-.06.63-.11,1.27-.17,1.92q-.24,2.73-.48,5.64c-.11,1.3-.22,2.62-.33,4-.08,1.05-.17,2.12-.25,3.21-3.34,43.07,2.32,70-7.79,95.85,0,0,0,0,0,0-4.6,9.2-8.94,16.07-13,21,0,.09,0,.19.08.28a152.31,152.31,0,0,0,40.61,65.89,150.47,150.47,0,0,0,26.35,20.12A149,149,0,0,0,382,571.5a152.35,152.35,0,0,0,58.82-81.14A114.4,114.4,0,0,1,428.28,469.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.3,290.27c-13.69-5.37-26-3.18-74.08,11.6S66,319.22,63.3,323.32c-7.54,11.39-6.27,27.17,17,80.78,28,64.45,41.92,96.67,54.73,97.25a12.09,12.09,0,0,0,2.39-.12h0a16.87,16.87,0,0,0,6.38-2.39,30.57,30.57,0,0,0,5.45-4.32,50.8,50.8,0,0,0,3.58-3.93c4.09-5,8.43-11.83,13-21,0,0,0,0,0,0,10.11-25.84,4.45-52.78,7.79-95.85.08-1.09.17-2.16.25-3.21.11-1.36.22-2.68.33-4q.24-2.91.48-5.64c.06-.65.11-1.29.17-1.92q.45-4.92.88-9.28c.07-.69.13-1.37.2-2s.14-1.34.21-2,.13-1.29.2-1.93c.14-1.26.27-2.48.4-3.66.66-5.92,1.29-10.86,1.85-14.9l.12-.83c0-.14,0-.28.05-.41.05-.4.11-.8.17-1.18s.08-.51.11-.76c.22-1.5.43-2.85.62-4.05v0c0-.4,0-.79,0-1.2l-.43.36.43-.37.17-.14a94.74,94.74,0,0,1,21.6-13.59q2.92-1.34,5.95-2.48A52.75,52.75,0,0,0,191.3,290.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M530.84,323.67c-2.71-4.1-6-6.7-53.92-21.45s-60.39-17-74.08-11.6a52.61,52.61,0,0,0-16.06,10.07q3,1.15,5.91,2.51A95.2,95.2,0,0,1,414.23,317l.12.72c0,.17,0,.33.08.51v0c.2,1.2.4,2.55.62,4.05,0,.25.07.5.11.76.12.76.23,1.57.34,2.42.56,4,1.19,9,1.85,14.9.13,1.18.26,2.41.4,3.67.1.89.19,1.81.29,2.75l.12,1.16c.07.67.14,1.36.2,2.05.28,2.81.57,5.79.85,8.95.07.74.13,1.48.2,2.24s.14,1.61.21,2.44c.09,1.05.18,2.12.27,3.2.11,1.3.22,2.63.33,4,.08,1.05.17,2.12.25,3.21,3.34,43.07-2.32,70,7.79,95.85l0,0a114.4,114.4,0,0,0,12.56,20.45l.47.58a50.8,50.8,0,0,0,3.58,3.93,30.57,30.57,0,0,0,5.45,4.32,16.87,16.87,0,0,0,6.38,2.39h0a12.09,12.09,0,0,0,2.39.12c12.81-.58,26.78-32.8,54.73-97.25C537.11,350.84,538.38,335.06,530.84,323.67Zm-116.18-6.43,0,0-.25-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.53,302.92a94.74,94.74,0,0,0-21.6,13.59c-.07.43-.15.88-.22,1.35,0-.4,0-.79,0-1.2h0c.56-8.21,5.11-16.32,10.94-17.68C194.24,298.15,197.81,299.92,201.53,302.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.43,318.21c0-.18-.06-.34-.08-.51l-.12-.72a95.2,95.2,0,0,0-21.54-13.78c3.69-3,7.23-4.7,10.74-3.89,5.84,1.36,10.39,9.48,10.95,17.69h0a.41.41,0,0,1,0,.11C414.41,317.49,414.43,317.85,414.43,318.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "383.49 280.6 478.62 158.56 421.7 142.78 444.82 59.4 349.3 166.36 410.46 183.32 383.49 280.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "288.94 219.86 226.18 86.5 282.37 83.79 278.39 1.46 344.69 120.89 284.31 123.81 288.94 219.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "226.23 259.71 204.39 159.47 172.2 181.78 139.52 134.62 153.5 228.67 188.09 204.7 226.23 259.71"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 237.24,
    cy: 402.68,
    r: 24.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 245.57,
    cy: 392.63,
    r: 8.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.52,
    cy: 402.68,
    r: 24.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 369.84,
    cy: 392.63,
    r: 8.02
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.55,
    cy: 568.19,
    rx: 41.67,
    ry: 18.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.15,517c4.33,41-27.41,84.35-50.07,83-19.17-1.14-24-33.8-45-34.41-21.87-.63-28.83,34.18-48.9,34.41-22.51.25-51-43.11-46.22-83,5.15-42.91,48.48-78.81,95.11-78.81S390.58,473.86,395.15,517Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "muzzle"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 300.05,
    y1: 487.19,
    x2: 300.05,
    y2: 566.59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19,466.63c6.33-16.06,63-16.12,69.37,0,4.23,10.63-10.35,36-34.41,36.15C274.81,503,260,477.3,264.19,466.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 317.89,
    cy: 467.22,
    rx: 5.33,
    ry: 10,
    transform: "translate(-217.43 648.28) rotate(-74.46)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcpi);
export default __webpack_public_path__ + "static/media/hcpi.78aff23533904557f5aa9c329e885cff.svg";
export { ForwardRef as ReactComponent };